import { render } from "./BoxImage.vue?vue&type=template&id=08082b82"
const script = {}
script.render = render

export default script